import { RequestFormCustomFieldProperty } from './customFieldTypes'

export const isCustomFieldQuestion = <T extends object>(
  question: T
): question is T & { customField: RequestFormCustomFieldProperty } => 'customField' in question && !!question.customField
